(function (angular) {
  var controllerId = "forgotPasswordController";
  angular
    .module("app")
    .controller(controllerId, ["$scope", "$location", "Messages", "alkAuthenticationService", "ALKForgotPassword", function ($scope, $location, Messages, alkAuthenticationService, ALKForgotPassword) {
      $scope.isProcessing = false;

      var redirectTo = $location.search().r;

      $scope.submitForgotPassword = function () {
        $scope.isProcessing = true;
        Messages.clear();

        var forgotPassword = new ALKForgotPassword($scope.email, redirectTo);

        alkAuthenticationService.forgotPassword(forgotPassword)
          .then(function () {
            Messages.add("success", "An email has been sent to your email address to reset your password.", {
              showOnNextPage: false
            });
          }, function (err) {
            if (err && err.data && err.data.Message) {
              Messages.add("danger", err.data.Message, {
                showOnNextPage: false
              });
            } else {
              Messages.add("danger", "Error while sending Forgot Password email.", {
                showOnNextPage: false
              });
            }
          }).finally(function () {
            $scope.isProcessing = false;
          });
      };
    }]);
})(window.angular);



// WEBPACK FOOTER //
// ./app/account/forgotPassword.controller.js